import { useEffect, useState } from 'react';
import { CONVERSATION_DRAG_TYPE } from '../types';

const isConversationDrag = (event: DragEvent) =>
  Boolean(event.dataTransfer?.types.includes(CONVERSATION_DRAG_TYPE));

/** True while a conversation from the sidebar list is being dragged. */
export const useConversationDragActive = () => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleStart = (event: DragEvent) => setIsDragging(isConversationDrag(event));
    const handleEnd = () => setIsDragging(false);

    window.addEventListener('dragstart', handleStart);
    window.addEventListener('dragend', handleEnd);
    window.addEventListener('drop', handleEnd);
    return () => {
      window.removeEventListener('dragstart', handleStart);
      window.removeEventListener('dragend', handleEnd);
      window.removeEventListener('drop', handleEnd);
    };
  }, []);

  return isDragging;
};
